import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Game from './components/Game';
import { Analytics } from "@vercel/analytics/react"

const wordList = [
  "CHARISMATIC",
  "WHIMSICAL",
  "WHIRLWIND",
  "EUPHORIA",
  "PARADIGM",
  "ELOQUENT",
  "EPHEMERAL",
  "LUMINOUS",
  "PRISTINE",
  "RESILIENT",
  "QUIXOTIC",
  "MELANCHOLY",
  "FROSTBITE",
  "VIBRATING",
  "KALEIDOSCOPE",
  "SERENDIPITY",
  "BLISTERING",
  "MAELSTROM",
  "CATACLYSM",
  "PHANTASM",
];

function getDailyWord() {
  const startDate = new Date("2024-01-01").getTime();
  const today = new Date().getTime();
  const daysSinceStart = Math.floor(
    (today - startDate) / (1000 * 60 * 60 * 24),
  );
  return wordList[daysSinceStart % wordList.length];
}

function App() {
  const dailyWord = getDailyWord();
  const sanitizedWord = dailyWord.replace(/[^a-zA-Z]/g, "");

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game" element={<Game word={sanitizedWord} />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
